(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    

jQuery('.chat-cta-block').each(function(){
  var from = this.getAttribute('timeframe-from');
  var to = this.getAttribute('timeframe-to');
  var timeFrom = new Date().setHours(+from, 0, 0);
  var timeTo = new Date().setHours(+to, 0, 0);

  var now = new Date().getTime();

  if(now > timeFrom && now < timeTo){
    jQuery(this).addClass('visible');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fembites-ritual-quiz"] && !Shopify.designMode) return;
  try {
    
  var RQ_CHEERS = {
    lifephase: 'Schön \u2013 das hilft uns schon weiter! \u2728',
    contraception: 'Danke für dein Vertrauen \ud83d\udc9c',
    focus: 'Wir kommen deinem Ritual näher \u2026',
    nutrition: 'Fast geschafft!',
    age: 'Nur noch ein Schritt \ud83c\udf89'
  };

  class FembitesRitualQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.answers = {};
      this.history = [];
      this.current = 'intro';
      this.sent = false;

      this.dots = this.querySelectorAll('.ritual-quiz__dot');
      this.steps = this.querySelectorAll('.ritual-quiz__step');

      /* Die Reihenfolge der Fragen kommt aus den Section-Bloecken. Sie steht
         deshalb im DOM und nicht mehr in einer festen Liste im Skript.
         Ergebniskarten sind keine Schritte und fallen hier raus. */
      this.order = Array.prototype.map
        .call(this.steps, (step) => step.dataset.step)
        .filter((name) => name !== 'result');

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);

      this.show('intro', { silent: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      window.clearTimeout(this.advanceTimer);
      this.ready = false;
    }

    /* ---------- Navigation ---------- */

    stepEl(name) {
      return this.querySelector('.ritual-quiz__step[data-step="' + name + '"]');
    }

    show(name, options) {
      const opts = options || {};
      const target = opts.element || this.stepEl(name);
      if (!target) return;

      this.steps.forEach((step) => {
        step.classList.remove('is-active');
        step.hidden = step !== target;
      });
      target.hidden = false;
      target.classList.add('is-active');
      this.current = name;

      this.renderDots(name);
      this.querySelectorAll('.ritual-quiz__cheer').forEach((el) => el.remove());

      if (opts.cheerFrom && RQ_CHEERS[opts.cheerFrom]) {
        const cheer = document.createElement('p');
        cheer.className = 'ritual-quiz__cheer';
        cheer.textContent = RQ_CHEERS[opts.cheerFrom];
        const heading = target.querySelector('.ritual-quiz__heading');
        if (heading) heading.insertAdjacentElement('beforebegin', cheer);
      }

      const back = target.querySelector('.ritual-quiz__back');
      if (back) back.hidden = this.history.length === 0;

      if (!opts.silent) {
        const heading = target.querySelector('.ritual-quiz__heading');
        if (heading) heading.focus({ preventScroll: true });
        /* Das Ergebnis ist kein Fragenschritt, es wird über fembites_quiz_lead gemessen. */
        if (name !== 'result') this.push('fembites_quiz_step', { quiz_step: name });
      }
    }

    goTo(name) {
      const from = this.current;
      this.history.push(from);
      this.show(name, { cheerFrom: from });
    }

    goBack() {
      const previous = this.history.pop();
      if (!previous) return;
      this.show(previous, { silent: true });
    }

    next(from) {
      const index = this.order.indexOf(from);
      if (index < 0 || index >= this.order.length - 1) return;
      this.goTo(this.order[index + 1]);
    }

    renderDots(name) {
      const index = this.order.indexOf(name) - 1;
      const done = name === 'result';
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('ritual-quiz__dot--done', done || i < index);
        dot.classList.toggle('ritual-quiz__dot--current', !done && i === index);
      });
    }

    /* ---------- Events ---------- */

    onChange(event) {
      const input = event.target.closest('input[type="radio"]');
      if (!input) return;
      const group = input.closest('.ritual-quiz__options');
      if (!group) return;

      this.answers[group.dataset.field] = input.value;
      this.queueNext(input.closest('.ritual-quiz__step').dataset.step);
    }

    /* Klick und change feuern beide. Ein gemeinsamer, entprellter Timer sorgt
       dafür, dass daraus genau ein Schrittwechsel und ein Tracking-Event wird. */
    queueNext(step) {
      window.clearTimeout(this.advanceTimer);
      this.advanceTimer = window.setTimeout(() => {
        if (this.current === step) this.next(step);
      }, 260);
    }

    onClick(event) {
      if (event.target.closest('.ritual-quiz__back')) {
        event.preventDefault();
        this.goBack();
        return;
      }
      const nextButton = event.target.closest('.ritual-quiz__next');
      if (nextButton) {
        event.preventDefault();
        this.push('fembites_quiz_start', {});
        this.next(nextButton.closest('.ritual-quiz__step').dataset.step);
        return;
      }

      /* Nach dem Zurückgehen feuert change nicht mehr, wenn dieselbe Option
         erneut gewählt wird. Ohne das hier bliebe die Nutzerin hängen. */
      const option = event.target.closest('.ritual-quiz__option');
      if (option) {
        const input = option.querySelector('input[type="radio"]');
        if (input && input.checked) {
          this.answers[option.closest('.ritual-quiz__options').dataset.field] = input.value;
          this.queueNext(option.closest('.ritual-quiz__step').dataset.step);
        }
      }
    }

    onSubmit(event) {
      const form = event.target.closest('.ritual-quiz__form');
      if (!form) return;
      event.preventDefault();

      if (form.dataset.field === 'first_name') {
        const input = form.querySelector('[name="first_name"]');
        const value = input.value.trim();
        if (!value) {
          input.focus();
          return;
        }
        this.answers.first_name = value;
        this.next('name');
        return;
      }

      if (form.dataset.field === 'email') this.submitEmail(form);
    }

    /* ---------- Abschluss ---------- */

    submitEmail(form) {
      const step = form.closest('.ritual-quiz__step');
      const emailInput = form.querySelector('[name="email"]');
      const consent = form.querySelector('[name="consent"]');
      const error = step.querySelector('.ritual-quiz__error');
      const button = form.querySelector('.ritual-quiz__submit');
      const email = emailInput.value.trim();

      error.hidden = true;

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        error.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
        error.hidden = false;
        emailInput.focus();
        return;
      }
      if (!consent.checked) {
        error.textContent = 'Bitte bestätige die Einwilligung, um dein Ergebnis zu erhalten.';
        error.hidden = false;
        consent.focus();
        return;
      }
      if (this.sent) return;
      this.sent = true;

      this.answers.email = email;

      /* Die Empfehlung wird VOR dem Versand aufgeloest, sonst geht sie leer an Klaviyo. */
      const result = this.resolve();
      this.answers.recommendation = result.key;

      const originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = 'Einen Moment …';

      this.sendToKlaviyo(result)
        .then(() => {
          this.push('fembites_quiz_lead', {
            quiz_recommendation: result.key,
            quiz_focus: this.answers.focus || '',
            quiz_lifephase: this.answers.lifephase || ''
          });
          this.trackMetaLead(result);
        })
        .catch((reason) => {
          /* Der Lead ist verloren. Sichtbar machen statt still verschlucken. */
          console.warn('[ritual-quiz] Klaviyo-Übermittlung fehlgeschlagen:', reason);
          this.push('fembites_quiz_lead_error', {
            quiz_error: String(reason && reason.message ? reason.message : reason)
          });
        })
        .then(() => {
          button.disabled = false;
          button.textContent = originalLabel;
          this.renderResult(result);
        });
    }

    resolve() {
      const answers = this.answers;
      const waitlist = this.dataset.menopauseMode === 'waitlist';

      let key = 'basic';
      if (answers.contraception === 'abgesetzt') {
        key = 'postpill';
      } else if (answers.lifephase === 'perimenopause' || answers.lifephase === 'menopause') {
        key = waitlist ? 'waitlist' : 'menopause';
      } else if (answers.lifephase === 'nach_schwangerschaft') {
        key = 'cleanse';
      } else if (answers.focus) {
        key = answers.focus;
      }

      let element = this.querySelector('.ritual-quiz__result[data-result="' + key + '"]');
      if (!element) {
        /* Kein Produkt im Theme-Editor gesetzt: auf die Grundversorgung zurückfallen. */
        element = this.querySelector('.ritual-quiz__result[data-result="basic"]')
          || this.querySelector('.ritual-quiz__result');
        if (element) key = element.dataset.result;
      }

      return { key: key, element: element };
    }

    renderResult(result) {
      if (!result.element) return;
      this.history = [];
      this.renderDots('result');

      const copy = result.element.querySelector('.ritual-quiz__result-copy');
      if (copy && this.answers.first_name && copy.dataset.copy) {
        const text = copy.dataset.copy;
        copy.textContent = this.answers.first_name + ', ' + text.charAt(0).toLowerCase() + text.slice(1);
      }

      this.show('result', { element: result.element });
    }

    /* ---------- Datenübermittlung ---------- */

    sendToKlaviyo(result, attempt) {
      const company = this.dataset.klaviyoCompany;
      if (!company) return Promise.resolve();

      const listWaitlist = this.dataset.klaviyoListWaitlist;
      const listId = result.key === 'waitlist' && listWaitlist ? listWaitlist : this.dataset.klaviyoList;
      if (!listId) return Promise.resolve();

      const answers = this.answers;
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.dataset.klaviyoSource || 'Ritual Finder',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: answers.email,
                  first_name: answers.first_name || '',
                  properties: {
                    quiz_focus: answers.focus || '',
                    quiz_recommendation: answers.recommendation || '',
                    quiz_lifephase: answers.lifephase || '',
                    quiz_contraception: answers.contraception || '',
                    quiz_age_range: answers.age_range || '',
                    quiz_nutrition: answers.nutrition || '',
                    quiz_completed_at: new Date().toISOString()
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company);

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then((response) => {
        if (response.ok) return response;
        /* Ein 4xx oder 5xx ist bei fetch keine Rejection. Also selbst pruefen. */
        if (!attempt) return this.sendToKlaviyo(result, 1);
        throw new Error('Klaviyo antwortete mit ' + response.status);
      });
    }

    push(event, payload) {
      if (this.dataset.datalayer !== 'true') return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload));
    }

    trackMetaLead(result) {
      if (this.dataset.metaLead !== 'true') return;
      if (typeof window.fbq !== 'function') return;
      window.fbq('track', 'Lead', { content_name: result.key });
    }
  }

  if (!customElements.get('fembites-ritual-quiz')) {
    customElements.define('fembites-ritual-quiz', FembitesRitualQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header') || this.closest('.shopify-section');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
